export default __webpack_public_path__ + "static/media/reward-bg.88f76294.png";